import { closeOnboardingPopup } from '../../services/onboarding/onboarding'
import { config } from '../../components/Init/Init'
import redeemRewardNotification from '../../sweepstakes/redeemRewardNotification'
import { getPlayerStatus } from '../../services/helpers/playerHelper'
import { useCallback } from 'react'
import { useStateValue } from '../../services/state/StateProvider'
import { useRemoveClaimCenter } from './useRemoveClaimCenter'
import { getNotificationCtaForCtaNumber } from '../../services/utils'
import { useCasinoStore, usePlayerStore } from '../../services/store'
import { useRemoveNoticeById } from '../../services/store/playerStore/playerActions'
import { useSetCasinoActiveNotificationId } from '../../services/store/casinoStore/casinoActions'
import { useIsCasinoLiteMode } from '../useIsCasinoLiteMode'

export const useCloseNotification = removeNotificationFromFirebase => {
  const [{ modals }, dispatch] = useStateValue()

  const playerStore = usePlayerStore()
  const playerData = playerStore.useAllPlayerStore()
  const playerSocialData = playerStore.use.socialData()
  const playerUserId = playerStore.use.userId()

  const { removeClaimCenter } = useRemoveClaimCenter()
  const { removeNoticeById } = useRemoveNoticeById()
  const { setCasinoActiveNotificationId } = useSetCasinoActiveNotificationId()
  const { isCasinoLiteModeWithPathIgnore } = useIsCasinoLiteMode()
  const casinoStore = useCasinoStore()
  const casinoActiveNotificationId = casinoStore.use.casinoActiveNotificationId()

  const closeNotification = useCallback(
    (notificationId, { actionUrl, modalData } = { actionUrl: null, modalData: null }) => {
      const internalModalData = modalData || modals.popup.data

      let notificationIdCopy = notificationId

      if (internalModalData.id !== notificationIdCopy) {
        notificationIdCopy = internalModalData.id
      }
      closeOnboardingPopup(internalModalData.type, playerUserId)

      // TODO: delete after remove CasinoLite.js
      if (actionUrl && actionUrl.includes('game/R/') && isCasinoLiteModeWithPathIgnore && internalModalData) {
        localStorage.setItem('notificationToDelete', JSON.stringify(internalModalData))
      }

      const cta = getNotificationCtaForCtaNumber(internalModalData)
      if (config.enableSweepstakes && config.enableRedeemNotification && cta && cta.rewardId) {
        // Try to redeem when popup is getting closed (i.e. via Close button)
        // redeemRewardNotification function will check if rewardId was already used last
        redeemRewardNotification(playerData, playerSocialData, internalModalData.id, cta.rewardId, {
          removeNoticeById
        }).then(() => {
          if (internalModalData.id && internalModalData.id === casinoActiveNotificationId) {
            setCasinoActiveNotificationId(null)
          }
        })

        // When we first release the claim center, it may be possible for popups to be open but then
        // moved to the claim center in Firebase... make sure we remove from pending in claim center
        if (
          config.enableClaimCenter &&
          Object.values(config.claimCenterNotificationTypes).indexOf(internalModalData.type) >= 0
        ) {
          removeClaimCenter(internalModalData.id)
        }
      } else if (getPlayerStatus(playerData) === 'logged-in' && config.enableRemoveNotice) {
        // remove current notice
        if (notificationIdCopy !== undefined) {
          removeNotificationFromFirebase(notificationIdCopy)

          removeNoticeById(notificationIdCopy)

          setCasinoActiveNotificationId(null)
        }
      }

      dispatch({
        type: 'setModal',
        modals: {
          popup: {
            display: false,
            data: {}
          }
        }
      })
    },
    [dispatch, modals, playerData, removeClaimCenter, removeNotificationFromFirebase]
  )

  return { closeNotification }
}
